// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   PlantillesExplorador.css
   Prefixe "pe-" per evitar col·lisions amb Dashboard.css
   ============================================================ */

/* --- Contenidor arrel --- */
.pe-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* --- Barra mode vinculació --- */
.pe-vinculacio-bar {
  padding: 8px 14px;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.pe-vinculacio-bar .pe-spacer {
  flex: 1 1;
}

/* --- Zona de cerca (fila superior) --- */
.pe-cerca-zona {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.pe-cerca-camp {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pe-cerca-label {
  white-space: nowrap;
  font-weight: 500;
  font-size: 0.9em;
}

.pe-cerca-input {
  padding: 4px 8px;
  font-size: 0.9em;
}

.pe-cerca-input--categoria {
  width: 160px;
}

.pe-cerca-input--plantilla {
  width: 200px;
}

.pe-cerca-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85em;
}

/* --- Resultats cerca categories (dropdown) --- */
.pe-cerca-resultats {
  padding: 4px 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  max-height: 120px;
  overflow-y: auto;
}

.pe-cerca-resultat-item {
  padding: 2px 6px;
  cursor: pointer;
}

.pe-cerca-resultat-item:hover {
  background-color: #e0e0e0;
}

/* --- Breadcrumb / ruta categoria --- */
.pe-breadcrumb {
  font-size: 0.85em;
  color: #555;
  padding: 2px 8px;
}

/* --- Layout principal: arbre + llista --- */
.pe-contingut {
  display: flex;
  gap: 16px;
  min-height: 400px;
}

/* --- Columna esquerra: arbre categories --- */
.pe-categories-panel {
  width: 280px;
  min-width: 220px;
  border-right: 1px solid #ddd;
  padding-right: 12px;
  overflow-y: auto;
}

/* --- Capçalera de secció (categories / plantilles) --- */
.pe-seccio-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.pe-seccio-titol {
  flex: 1 1;
  font-size: 0.95em;
  font-weight: bold;
}

/* --- Formulari inline nou/editar (categories) --- */
.pe-inline-form {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.pe-inline-input {
  flex: 1 1;
  padding: 3px 6px;
  font-size: 0.9em;
}

/* --- Node "Totes les plantilles" --- */
.pe-node-totes {
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 3px;
  font-style: italic;
  margin-bottom: 4px;
}

.pe-node-totes--selected {
  background-color: #d0e8ff;
  font-weight: bold;
}

/* --- Arbre de categories --- */
.pe-tree {
  list-style: none;
  margin: 0;
}

.pe-tree--root {
  padding-left: 0;
}

.pe-tree--nested {
  padding-left: 16px;
}

.pe-tree-node {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 3px;
}

.pe-tree-node--selected {
  background-color: #d0e8ff;
  font-weight: bold;
}

.pe-tree-expand-icon {
  width: 16px;
  display: inline-block;
  text-align: center;
}

.pe-tree-edit-input {
  font-size: 0.9em;
  padding: 1px 4px;
  width: 140px;
}

/* --- Columna dreta: llista plantilles --- */
.pe-plantilles-panel {
  flex: 1 1;
  overflow-y: auto;
}

/* --- Botons vincular/desvincular (mida petita) --- */
.pe-btn-petit {
  padding: 3px 10px;
  font-size: 0.85em;
}

/* --- Formulari nova / editar plantilla --- */
.pe-form-plantilla {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.pe-form-plantilla--nou {
  background-color: #f8f9fa;
}

.pe-form-plantilla--editar {
  background-color: #fff8e1;
}

.pe-form-plantilla input {
  padding: 4px 8px;
  font-size: 0.9em;
}

.pe-form-btn-row {
  display: flex;
  gap: 6px;
}

.pe-form-btn-petit {
  padding: 3px 12px;
  font-size: 0.85em;
}

/* --- Cel·la categories dins la taula --- */
.pe-td-categories {
  font-size: 0.85em;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/PlantillesExplorador.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["/* ============================================================\r\n   PlantillesExplorador.css\r\n   Prefixe \"pe-\" per evitar col·lisions amb Dashboard.css\r\n   ============================================================ */\r\n\r\n/* --- Contenidor arrel --- */\r\n.pe-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* --- Barra mode vinculació --- */\r\n.pe-vinculacio-bar {\r\n  padding: 8px 14px;\r\n  background-color: #fff3cd;\r\n  border: 1px solid #ffc107;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.pe-vinculacio-bar .pe-spacer {\r\n  flex: 1;\r\n}\r\n\r\n/* --- Zona de cerca (fila superior) --- */\r\n.pe-cerca-zona {\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.pe-cerca-camp {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.pe-cerca-label {\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.pe-cerca-input {\r\n  padding: 4px 8px;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.pe-cerca-input--categoria {\r\n  width: 160px;\r\n}\r\n\r\n.pe-cerca-input--plantilla {\r\n  width: 200px;\r\n}\r\n\r\n.pe-cerca-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.85em;\r\n}\r\n\r\n/* --- Resultats cerca categories (dropdown) --- */\r\n.pe-cerca-resultats {\r\n  padding: 4px 10px;\r\n  background-color: #f0f0f0;\r\n  border-radius: 4px;\r\n  max-height: 120px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.pe-cerca-resultat-item {\r\n  padding: 2px 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.pe-cerca-resultat-item:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n/* --- Breadcrumb / ruta categoria --- */\r\n.pe-breadcrumb {\r\n  font-size: 0.85em;\r\n  color: #555;\r\n  padding: 2px 8px;\r\n}\r\n\r\n/* --- Layout principal: arbre + llista --- */\r\n.pe-contingut {\r\n  display: flex;\r\n  gap: 16px;\r\n  min-height: 400px;\r\n}\r\n\r\n/* --- Columna esquerra: arbre categories --- */\r\n.pe-categories-panel {\r\n  width: 280px;\r\n  min-width: 220px;\r\n  border-right: 1px solid #ddd;\r\n  padding-right: 12px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* --- Capçalera de secció (categories / plantilles) --- */\r\n.pe-seccio-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.pe-seccio-titol {\r\n  flex: 1;\r\n  font-size: 0.95em;\r\n  font-weight: bold;\r\n}\r\n\r\n/* --- Formulari inline nou/editar (categories) --- */\r\n.pe-inline-form {\r\n  display: flex;\r\n  gap: 4px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.pe-inline-input {\r\n  flex: 1;\r\n  padding: 3px 6px;\r\n  font-size: 0.9em;\r\n}\r\n\r\n/* --- Node \"Totes les plantilles\" --- */\r\n.pe-node-totes {\r\n  padding: 3px 6px;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n  font-style: italic;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.pe-node-totes--selected {\r\n  background-color: #d0e8ff;\r\n  font-weight: bold;\r\n}\r\n\r\n/* --- Arbre de categories --- */\r\n.pe-tree {\r\n  list-style: none;\r\n  margin: 0;\r\n}\r\n\r\n.pe-tree--root {\r\n  padding-left: 0;\r\n}\r\n\r\n.pe-tree--nested {\r\n  padding-left: 16px;\r\n}\r\n\r\n.pe-tree-node {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 6px;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n}\r\n\r\n.pe-tree-node--selected {\r\n  background-color: #d0e8ff;\r\n  font-weight: bold;\r\n}\r\n\r\n.pe-tree-expand-icon {\r\n  width: 16px;\r\n  display: inline-block;\r\n  text-align: center;\r\n}\r\n\r\n.pe-tree-edit-input {\r\n  font-size: 0.9em;\r\n  padding: 1px 4px;\r\n  width: 140px;\r\n}\r\n\r\n/* --- Columna dreta: llista plantilles --- */\r\n.pe-plantilles-panel {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* --- Botons vincular/desvincular (mida petita) --- */\r\n.pe-btn-petit {\r\n  padding: 3px 10px;\r\n  font-size: 0.85em;\r\n}\r\n\r\n/* --- Formulari nova / editar plantilla --- */\r\n.pe-form-plantilla {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.pe-form-plantilla--nou {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.pe-form-plantilla--editar {\r\n  background-color: #fff8e1;\r\n}\r\n\r\n.pe-form-plantilla input {\r\n  padding: 4px 8px;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.pe-form-btn-row {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.pe-form-btn-petit {\r\n  padding: 3px 12px;\r\n  font-size: 0.85em;\r\n}\r\n\r\n/* --- Cel·la categories dins la taula --- */\r\n.pe-td-categories {\r\n  font-size: 0.85em;\r\n  color: #666;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
